import { MANSION } from "@constants/images";
import { useState } from "react";
import ArtView from "@components/common/ArtView.component";

const Carousel = () => {
  const [imageExternalIndex, setImageExternalIndex] = useState(0);
  const [imageInternalIndex, setImageInternalIndex] = useState(0);
  const [showArtView, setShowArtView] = useState(false);
  const imagesList = MANSION.CAROUSEL_IMAGES;

  const [showModal, setShowModal] = useState(false);

  return (
    <div className="carousel-wrapper">
      <h4 className="carousel-text">Emerald city sneak peek</h4>
      <p className="carousel-text-details">
        The image below is a not the final version and may vary from the actual asset.
      </p>
      <div className="carousel-image-div">
        <img
          className="carousle-selected-image"
          width={"420px"}
          height={"591px"}
          src={imagesList[imageExternalIndex][imageInternalIndex]}
          alt={`carousel-${imageExternalIndex}`}
          onClick={() => {
            setShowArtView(true);
          }}
        />

        <div
          className={`image-diff-view-wrapper ${!showModal && "set-image-top"}`}
        >
          {[0, 1, 2, 3].map((value, index) => {
            return (
              <div key={index} className="image-diff-view">
                <img
                  width={"100%"}
                  className={`diff-view ${
                    value === imageInternalIndex && "selected-carousel"
                  }`}
                  onClick={() => {
                    setImageInternalIndex(value);
                  }}
                  src={imagesList[imageExternalIndex][value]}
                  alt={`carousel-${imageExternalIndex}`}
                />
              </div>
            );
          })}
        </div>
      </div>

      <img
        onClick={() => {
          setImageInternalIndex(0);
          imageExternalIndex === 0
            ? setImageExternalIndex(imagesList.length - 1)
            : setImageExternalIndex(imageExternalIndex - 1);
        }}
        className="carousel-next-left"
        src={MANSION.CAROUSEL_NEXT_ICON}
        alt="next-icon-left"
      />
      <img
        onClick={() => {
          setImageInternalIndex(0);
          imageExternalIndex === imagesList.length - 1
            ? setImageExternalIndex(0)
            : setImageExternalIndex(imageExternalIndex + 1);
        }}
        className="carousel-next-right"
        src={MANSION.CAROUSEL_NEXT_ICON}
        alt="next-icon-right"
      />

      {showArtView && (
        <ArtView
          setShowImage={setShowArtView}
          image={imagesList[imageExternalIndex][imageInternalIndex]}
        />
      )}
    </div>
  );
};

export default Carousel;
